import type { SVGProps } from 'react';
const SvgCarRepair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#car_repair_svg__a)">
      <path
        fill="currentColor"
        d="M16.22 12c.68 0 1.22-.54 1.22-1.22 0-.67-.54-1.22-1.22-1.22-.68 0-1.22.55-1.22 1.22 0 .68.55 1.22 1.22 1.22Zm-9.66-1.22c0 .67.54 1.22 1.22 1.22.68 0 1.22-.54 1.22-1.22 0-.67-.54-1.22-1.22-1.22-.68 0-1.22.55-1.22 1.22ZM7.61 4 6.28 8h11.43l-1.33-4H7.61Zm8.67-1s.54.01.92.54c.02.02.03.04.05.07.07.11.14.24.19.4.22.65 1.56 4.68 1.56 4.68v6.5c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81V14H7v1.19c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81v-6.5S6.34 4.67 6.55 4c.05-.16.12-.28.19-.4.03-.02.04-.04.06-.06.38-.53.92-.54.92-.54h8.56ZM4 17.01h16V19h-7v3h-2v-3H4v-1.99Z"
      />
    </g>
    <defs>
      <clipPath id="car_repair_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCarRepair;
